// IE 2026 11 01 / ODOO-350449 (заказ Игоря через ie-webscm7-2 #122315: легенда вимк., колонка прапорців у Числах, чіп як селектор):
// приём чипса стола по СВОЕМУ каналу — как селектор, а не как отбор («по-моему, у нас это был глобальный подход»). Канал свой — виджет объявляет его
// Set-без-Get (Selection → Fields: selector_set_fields; selSetOnly_fields). Входящий чипс такого канала — от любого виджета (соседней карты, списка) —
// выборку НЕ сужает: строка чипса уходит бэку выключенной (workspace_params_for), перечитывания нет (updateRelatedWidgets пропускает виджет как
// «только свои Set-поля»), а совпадающие строки отмечаются флажком и подсвечиваются (теплокарта: вид «Кола» и «Числа» — по params.WHERE стола);
// снятие чипса снимает отметку. Чужие каналы (не свои) — как раньше: отбор.
// Выключатель fe.data.selectorOwnByWidget (дефолт ВКЛ) — «свой канал = отметка, не отбор». ВЫКЛ — в режиме виджета doc.params.selector_own_by_widget
// (теплокарты закупок, бэк attrs.selector_own_chip_by_widget) прежнее правило p165b: свой — только канал, чью строку чипса стола поставил ЭТОТ виджет
// (поле widget строки WHERE = id записи виджета, как пишет get_rowWHERE), чипс соседа — отбор с перечитыванием; нет строки (чипс снят) — не свой.
// Без ключа selector_own_by_widget — правило по имени канала (свой = отметка) при любом положении выключателя.
// Чистая логика без Vue — юнит tests/unit/selectorOwnByWidget.test.mjs

const _str = (v) => (v === null || v === undefined) ? '' : String(v).trim()

// ids записи виджета, которыми фронт подписывает строку чипса (WIDGET.widget — get_rowWHERE; record.id — запись)
export function selOwnByWidget_ids(WIDGET) {
    return new Set([WIDGET?.widget, WIDGET?.record?.id].map(_str).filter(Boolean))
}

export function selOwnByWidget_on(WIDGET) {
    return !!WIDGET?.record?.doc?.params?.selector_own_by_widget
}

// fields — Set-без-Get каналы виджета (selSetOnly_fields); rows — строки WHERE стола (или копии параметров запроса);
// opts.mark — выключатель fe.data.selectorOwnByWidget (по умолчанию true: свой канал = отметка — все каналы остаются своими).
// Возвращает те каналы, что виджет считает своими (ими не режется, при их смене не перечитывается)
export function selOwnByWidget_filter(WIDGET, fields, rows, opts = {}) {   // IE 2026 11 01 / ODOO-350449 (заказ Игоря через ie-webscm7-2 #122315: легенда вимк., колонка прапорців у Числах, чіп як селектор)
    if (!Array.isArray(fields) || !fields.length || !selOwnByWidget_on(WIDGET)) return fields
    if (opts?.mark !== false) return fields   // IE 2026 11 01 / ODOO-350449 (заказ Игоря через ie-webscm7-2 #122315: легенда вимк., колонка прапорців у Числах, чіп як селектор): чипс своего канала — отметка
    const ids = selOwnByWidget_ids(WIDGET)
    const list = Array.isArray(rows) ? rows : []
    return fields.filter(f => {
        const r = list.find(x => x && x.leftValue?.value === f)
        return !!r && ids.has(_str(r.widget))
    })
}
